"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Escape = exports.unescapeXML = exports.escapeXML = void 0;
const XML_ESCAPE_MAP = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&apos;',
};
const XML_UNESCAPE_MAP = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&apos;': "'",
};
const TO_ESCAPE = /[&<>"']/g;
const TO_UNESCAPE = /&(?:amp|lt|gt|quot|apos);/g;
const doEscape = (ch) => XML_ESCAPE_MAP[ch];
const doUnEscape = (ch) => XML_UNESCAPE_MAP[ch];
const escapeXML = (s) => s.replace(TO_ESCAPE, doEscape);
exports.escapeXML = escapeXML;
const unescapeXML = (s) => s.replace(TO_UNESCAPE, doUnEscape);
exports.unescapeXML = unescapeXML;
exports.Escape = {
    escape: exports.escapeXML,
    unescape: exports.unescapeXML,
};
//# sourceMappingURL=escape.xml.js.map